import * as React from "react";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ACTIVATE_SRA_CUSTOMER } from "../actiontypes";
import { ApplicationState } from "../../../applicationState";
import { activateSraCustomer } from "../actions";

interface OwnProps {
    sraCustomerId: string;
}

interface DispatchProps {
    activate: (sraCustomerId: string) => void;
}

interface MergedProps {
    activate: () => void;
}

const ActivateSraCustomerButtonUnconnected: React.FunctionComponent<MergedProps> = (props) => {
    return (
        <IsLoadingButton positive content="Activate" onClick={props.activate} requestNames={ACTIVATE_SRA_CUSTOMER} />
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, any>) => ({
    activate: (sraCustomerId: string) => dispatch(activateSraCustomer(sraCustomerId))
});

const mergeProps = (stateProps: null, dispatchProps: DispatchProps, ownProps: OwnProps) => ({
    ...ownProps,
    activate: () => dispatchProps.activate(ownProps.sraCustomerId)
});

export const ActivateSraCustomerButton = connect(null, mapDispatchToProps, mergeProps)(ActivateSraCustomerButtonUnconnected);
